// extracted by mini-css-extract-plugin
module.exports = {"grid":"case-grid_grid__14eqS","minWidth":"case-grid_minWidth__1_Kk9"};